import { Edit, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Select, Tag, Space, Row, Col } from "antd";
import { IResourceComponentsProps } from "@refinedev/core";
import { SafetyCertificateOutlined, SettingOutlined, LinkOutlined } from "@ant-design/icons";

import { ILicence, IShipco, IShipcoGroup } from "interfaces";
import React from "react";
import { FormSection, FormFieldGrid } from "components/form";

export const LicenceEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    formProps,
    saveButtonProps,
    query,
    formLoading: isLoading,
  } = useForm<ILicence>();

  function ShipcoSelectComponent() {
    const { selectProps } = useSelect<IShipco>({
      resource: "shipco",
      optionLabel: "registrationName",
      optionValue: "id",
      filters: query?.data?.data?.shipco?.id
        ? [
            {
              field: "id",
              operator: "eq",
              value: query?.data?.data?.shipco?.id,
            },
          ]
        : [],
      pagination: {
        mode: "server"
      }
    });
    return (
      <Form.Item
        label="Shipco"
        name={["shipco", "id"]}
        initialValue={query?.data?.data?.shipco?.registrationName}
      >
        <Select {...selectProps} />
      </Form.Item>
    );
  }

  function ShipcoGroupSelectComponent() {
    const { selectProps } = useSelect<IShipcoGroup>({
      resource: "shipco-group",
      optionLabel: "registrationName",
      optionValue: "id",
      filters: query?.data?.data?.shipcoGroup?.id
        ? [
            {
              field: "id",
              operator: "eq",
              value: query?.data?.data?.shipcoGroup?.id || 0,
            },
          ]
        : [],
      pagination: {
        mode: "server"
      }
    });
    return (
      <Form.Item
        label="Shipco Group"
        name={["shipcoGroup", "id"]}
        initialValue={query?.data?.data?.shipcoGroup?.registrationName}
      >
        <Select {...selectProps} />
      </Form.Item>
    );
  }

  return (
    <Edit
      breadcrumb={false}
      saveButtonProps={saveButtonProps}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "edit licence",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical">
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Licence Details"
            subtitle="UKHO licence information"
            icon={<SafetyCertificateOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="UKHO Licence"
                name="ukhoLicenceId"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>

          <Row gutter={24}>
            <Col xs={24} lg={12}>
              <FormSection
                title="Delivery Settings"
                subtitle="Invoice and order configuration"
                icon={<SettingOutlined />}
              >
                <FormFieldGrid columns={1}>
                  <Form.Item label="Invoice Delivery" name="invoiceDelivery">
                    <Select
                      options={[
                        { label: "Email", value: "email" },
                        { label: "Download", value: "download" },
                        { label: "Both", value: "both" },
                      ]}
                    />
                  </Form.Item>
                  <Form.Item label="Purchase Order Required?" name="purchaseOrderReqd">
                    <Select
                      options={[
                        { label: "Not Required", value: "not required" },
                        { label: "Required", value: "required" },
                      ]}
                    />
                  </Form.Item>
                </FormFieldGrid>
              </FormSection>
            </Col>

            <Col xs={24} lg={12}>
              <FormSection
                title="Company Association"
                subtitle="Link to shipping company"
                icon={<LinkOutlined />}
              >
                {query?.isSuccess ? (
                  <>
                    <ShipcoSelectComponent />
                    <ShipcoGroupSelectComponent />
                  </>
                ) : null}
              </FormSection>
            </Col>
          </Row>
        </Space>
      </Form>
    </Edit>
  );
};
